
import NotFound from "./NotFound";
import RedirectHomeOrNotFound from './RedirectHomeOrNotFound';

const routes = [
    {path : '/', component: () => <RedirectHomeOrNotFound/>, isPublic : false, isSidebar : false},
    {path : '*', component: () => <NotFound/>, isPublic : true, isSidebar : false},
]

export default routes;